import { DataMapStructure } from './data-map';

export const driveWorkDataMap: DataMapStructure = {
  yes: { key: 'REPORTDATA.yes', fallback: 'Yes' },
  Yes: { key: 'REPORTDATA.yes', fallback: 'Yes' },
  no: { key: 'REPORTDATA.no', fallback: 'No' },
  No: { key: 'REPORTDATA.no', fallback: 'No' },
  'Not Started': { key: 'REPORTDATA.notStarted', fallback: 'Not Started' },
  'Not Assigned': { key: 'REPORTDATA.Not Assigned', fallback: 'Not Assigned' },
  private: { key: 'REPORTDATA.private', fallback: 'Privately owned vehicle' },
  company_owned_or_leased: { key: 'REPORTDATA.company_owned_or_leased', fallback: 'Company owned or leased vehicle' },
  company_pool_or_utility: { key: 'REPORTDATA.company_pool_or_utility', fallback: 'Company pool/utility vehicle' },
  company_hire_or_rental: { key: 'REPORTDATA.company_hire_or_rental', fallback: 'Hire/Rental vehicle' },
  car_scheme: { key: 'REPORTDATA.car_scheme', fallback: 'Car Scheme/SVP' },
  site_vehicle: { key: 'REPORTDATA.site_vehicle', fallback: 'Site Vehicle' },
  benefit_cash: { key: 'REPORTDATA.benefit_cash', fallback: 'Benefit Cash' },
  tool_of_trade: { key: 'REPORTDATA.tool_of_trade', fallback: 'Tool of Trade' },
  benefit_vehicle: { key: 'REPORTDATA.benefit_vehicle', fallback: 'Benefit Vehicle' },
};

export const courseActivityStatusDataMap: DataMapStructure = {
  na: { key: 'REPORTDATA.na', fallback: 'N/A' },
  noCoursesAssigned: { key: 'REPORTDATA.noCoursesAssigned', fallback: 'No Courses Assigned' },
  overdue: { key: 'REPORTDATA.overdue', fallback: 'Overdue' },
  incomplete: { key: 'REPORTDATA.incomplete', fallback: 'Incomplete' },
  complete: { key: 'REPORTDATA.complete', fallback: 'Complete' },
  notStarted: { key: 'REPORTDATA.notStarted', fallback: 'Not Started' },
};
